import { endOfDay, startOfDay } from "date-fns";

export type TripRange = { deviceId?: string; start: Date; stop: Date };

/** Merges trip ranges per device into one whole-day span (start of first day .. end of last day). */
export function mergeTripRangesByDevice(ranges: TripRange[]): Map<string, { from: Date; to: Date }> {
  const bounds = new Map<string, { min: number; max: number }>();

  for (const range of ranges) {
    if (!range.deviceId) continue;
    const existing = bounds.get(range.deviceId);
    bounds.set(range.deviceId, {
      min: Math.min(existing?.min ?? Infinity, range.start.getTime()),
      max: Math.max(existing?.max ?? -Infinity, range.stop.getTime()),
    });
  }

  const byDeviceId = new Map<string, { from: Date; to: Date }>();
  for (const [deviceId, { min, max }] of bounds) {
    byDeviceId.set(deviceId, { from: startOfDay(new Date(min)), to: endOfDay(new Date(max)) });
  }
  return byDeviceId;
}
